package one.healthium.paywall.ui.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.util.fastFirstOrNull
import ifaandroid.feature.paywall.paywall_ui.generated.resources.Res
import ifaandroid.feature.paywall.paywall_ui.generated.resources.ic_subtract
import one.healthium.domain.paywall.models.PaywallSecuredView
import one.healthium.paywall.ui.models.ProductUiModel
import one.healthium.ui.common.utils.toTextStyle
import one.healthium.ui.compose.theme.AppTheme
import org.jetbrains.compose.resources.painterResource

@Composable
fun PaywallSecuredView(model: PaywallSecuredView, products: List<ProductUiModel>, selectedProductId: String?) {
    if (model.config.text == null) return

    val product = remember(products, selectedProductId) {
        products.fastFirstOrNull { it.id == selectedProductId }
    }

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 64.dp),
        horizontalArrangement = Arrangement.Center,
    ) {
        Image(
            painter = painterResource(Res.drawable.ic_subtract),
            contentDescription = null,
        )
        Spacer(Modifier.width(8.dp))
        Text(
            text = model.config.text.parse(product, lowercase = true),
            style = model.config.textLabel.toTextStyle(AppTheme.textStyles.subline),
            textAlign = TextAlign.Center,
        )
    }
}
